import { styled } from "@mui/material/styles";
import {Box, Card, Switch, Typography} from "@mui/material";

export const PairCard = styled(Card)({
    display: "flex",
    flexDirection: "column",
    padding: "12px",
    borderRadius: "8px",
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
});

export const HeaderRow = styled(Box)({
    display: "flex",
    alignItems: "center",
    width: "100%",
});

export const IOSSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], { duration: 500 }),
    },
}));

export const StatusTextMultiline = styled(Typography)({
    fontSize: 12,
    color: "#666",
    wordBreak: "break-word",
    whiteSpace: "normal",
});